module.exports = __webpack_public_path__ + "static/media/TURKCELL_YATAY_ERKEK_LOGO.72be3fbd.png";